import React, {useContext} from 'react';
import {FaEdit} from 'react-icons/fa';
import {AppCtx, ViewTypes} from "../../../AppCtx";

/** @deprecated The Adorans read-only catalogue no longer offers the editor switch. */
export default () => {
  const {viewType, setViewType, selectedFile, setSelectedFile, songEditorLocationRef} = useContext(AppCtx);
  return <div onClick={() => {
    const saved = songEditorLocationRef?.current;
    if (viewType === ViewTypes.MONACO && saved?.fileName === selectedFile?.name && saved.preview) {saved.preview(); return;}
    if (viewType === ViewTypes.SONGS && setSelectedFile) {
      const root = document.querySelector('.song-view');
      const top = root?.getBoundingClientRect().top || 0;
      const visible = [...document.querySelectorAll('#songs .song')].find(node => node.getBoundingClientRect().bottom > top);
      const songNumber = Number(visible?.id.slice(5));
      if (songNumber) setSelectedFile(previous => ({...previous, songNumber}));
    }
    setViewType(viewType===ViewTypes.SONGS?ViewTypes.MONACO:ViewTypes.SONGS);
  }}
              style={{cursor:'pointer',borderRadius:'30%',padding:'5px',
                     backgroundColor:viewType===ViewTypes.MONACO?'var(--menu-icon-active-color)':'transparent'}}
              role="button" tabIndex={0}
              aria-label={viewType===ViewTypes.SONGS ? "Przełącz na widok edycji" : "Przełącz na widok piosenek"}
              title={viewType===ViewTypes.SONGS ? "Przełącz na widok edycji" : "Przełącz na widok piosenek"}>
    <FaEdit style={{color:viewType===ViewTypes.MONACO?'white':'var(--menu-icon-inactive-color)'}}/>
  </div>;
};
